module.exports = __webpack_public_path__ + "31ac9ca1af6059d462e29d3038be004e.png";